"use client"

import partVehicles from '@constants/values/partVehicles'

import { HintInput as Input } from './HintInput'
import { useInputValueStore } from './InputValueStoreProvider'
import cloneWithoutValidations from "@utils/forms/cloneWithoutValidations"
import useT from "@hooks/useTranslation"

import makeTruck from '@components/add/forms/inputs/markaTruck'
import modelTruck from '@components/add/forms/inputs/modelTruck'
import makeMotorcycle from '@components/add/forms/inputs/markaMotocykl'
import modelMotorcycle from '@components/add/forms/inputs/modelMotocykl'

import styles from '@components/add/forms/newEditForms/partFormPartials/partFitForVehicleInput.module.css'

const marka = { name: 'marka', t: 'Marka', hint: { url: '/part_make', isDepFor: ['model','generacja','wersja-silnikowa'], deps: ['pojazd'] }}
const model = { name: 'model', t: 'Model', hint: { url: '/part_model', isDepFor: ['generacja','wersja-silnikowa'], deps: ['marka'] }}
const generacja = { name: 'generacja', t: 'Generacja', hint: { url: '/part_generation', isDepFor: ['wersja-silnikowa'], deps: ['marka','model'], modeTextIncluded: true }}
const wersjaSilnikowa = { name: 'wersja-silnikowa', t: 'Wersja silnikowa', hint: { url: '/part_trim', deps: ['marka','model','generacja'], modeTextIncluded: true }}

const otherMakeInputs = {
    [partVehicles[1]]: cloneWithoutValidations(makeTruck),
    [partVehicles[2]]: cloneWithoutValidations(makeMotorcycle),
    [partVehicles[3]]: cloneWithoutValidations(makeTruck),
}

const otherModelInputs = {
    [partVehicles[1]]: cloneWithoutValidations(modelTruck),
    [partVehicles[2]]: cloneWithoutValidations(modelMotorcycle),
    [partVehicles[3]]: cloneWithoutValidations(modelTruck),
}

export function PartFitInput (props) {
    const { getValue } = useInputValueStore()
    const selectedVehicle = getValue('pojazd')
    const isCar = [partVehicles[0], partVehicles[4]].includes(selectedVehicle)
    const alternativeMakeInput = !isCar && selectedVehicle && otherMakeInputs[selectedVehicle]
    const alternativeModelInput = !isCar && selectedVehicle && otherModelInputs[selectedVehicle]

    const tFits = useT('Pasuje do')
    const titleFragment = <b className={styles.h}>{tFits}</b>

    if (!selectedVehicle) return null
    return isCar
        ? <>
            {titleFragment}
            <Input {...marka} {...props} />
            <Input {...model} {...props} />
            <Input {...generacja} {...props} />
            <Input {...wersjaSilnikowa} {...props} />
          </>

        : <>
            { (alternativeMakeInput || alternativeModelInput) && titleFragment }
            { alternativeMakeInput && <>
                <Input {...marka} {...props} />
            </> }
            { alternativeModelInput && <>
                <Input {...model} {...props} />
            </> }
          </>
}